import { ComponentPropsWithRef, ElementType } from 'react';
import type { IconComponent } from '../../themes/base/icons/types';
import { CommonButtonProps } from '../button/button.utils';
import { StyledIconButton } from './icon-button.styles';
import { Spinner } from '../progress-indicator/progress-indicator.styles';
import { Size } from '../../types';
import { WithTooltip } from '../tooltip';

type Props<Component extends ElementType = 'button'> = {
    icon: IconComponent;
    size?: Size;
    circular?: boolean;
    tooltip?: string;
    as?: Component;
} & Omit<ComponentPropsWithRef<Component>, 'size'> &
    CommonButtonProps;

export function IconButton<Component extends ElementType = 'button'>({
    icon: SvgIcon,
    loading,
    variant,
    circular,
    tooltip,
    ...rest
}: Props<Component>) {
    return (
        <WithTooltip text={tooltip} inline>
            <StyledIconButton variant={variant} type="button" $circular={circular} {...rest}>
                {loading && <Spinner opacity={0.5} />}
                {!loading && <SvgIcon />}
            </StyledIconButton>
        </WithTooltip>
    );
}
